import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol viewBox=\"0 0 20 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"menu\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0h20v2H0V0zm0 8h20v2H0V8zm0 8h20v2H0v-2z\" fill=\"#5E5E5E\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu.svg
// module id = 447
// module chunks = 0